import { Close } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Avatar, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Scrollbar } from 'app/components';
import { InspectionIcon } from 'app/icons';
import { ChecklistTemplateForm } from 'app/pages/Checklist';
import { useAsyncAction } from 'app/services';
import { templateCreate } from 'app/store/checklist';
import React, { useEffect, useRef } from 'react';
const ChecklistTemplateDialog = ({ open, onClose, defaultValues }) => {
    const formRef = useRef(null);
    const { asyncAction: createSubmit, isLoading: isCreateLoading, isSuccessful: isCreateSuccessful, } = useAsyncAction(templateCreate, [open]);
    useEffect(() => {
        if (isCreateSuccessful) {
            onClose();
        }
    }, [isCreateSuccessful]);
    return (React.createElement(Dialog, { maxWidth: 'md', fullWidth: true, open: open, onClose: onClose, sx: (theme) => ({
            width: '100%',
            height: '100%',
            '.MuiDialog-paper': {
                minWidth: '500px',
            },
            '.MuiDialogTitle-root': {
                display: 'flex',
                padding: theme.spacing(2),
                alignItems: 'center',
            },
            '.MuiDialogTitle-root .MuiTypography-root': {
                marginLeft: theme.spacing(1.5),
            },
            '.MuiDialogTitle-root .MuiButtonBase-root': {
                marginLeft: 'auto',
            },
            '.MuiDialogContent-root': {
                padding: theme.spacing(0),
            },
            '.MuiDialogContent-root .simplebar-container': {
                padding: theme.spacing(0, 2),
            },
            '.MuiDialogActions-root': {
                padding: theme.spacing(2),
                justifyContent: 'flex-end',
            },
            '.MuiAvatar-circular': {
                bgcolor: alpha(theme.palette.primary.main, 0.12),
                svg: {
                    width: '18px',
                    height: '18px',
                },
                'path, circle': {
                    fill: theme.palette.primary.main,
                },
            },
            '.MuiAlert-root': {
                marginTop: theme.spacing(1),
                marginBottom: theme.spacing(2),
                borderRadius: theme.shape.borderRadius,
            },
        }) },
        React.createElement(DialogTitle, null,
            React.createElement(Avatar, null,
                React.createElement(InspectionIcon, { fontSize: 'small' })),
            React.createElement(Typography, { component: 'p' }, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0448\u0430\u0431\u043B\u043E\u043D"),
            React.createElement(IconButton, { color: 'default', onClick: onClose },
                React.createElement(Close, { fontSize: 'small' }))),
        React.createElement(DialogContent, null,
            React.createElement(Scrollbar, null,
                React.createElement(ChecklistTemplateForm, { ref: formRef, defaultValues: defaultValues, onSubmit: createSubmit }))),
        React.createElement(DialogActions, null,
            React.createElement(LoadingButton, { variant: 'contained', color: 'primary', loading: isCreateLoading, onClick: () => { var _a; return (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.handleFormSubmit(); }, disableElevation: true }, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C"))));
};
export default ChecklistTemplateDialog;
